import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSharedUIModule, DialogService } from 'app-shared-ui';
import { TranslocoRootModule } from 'app-core';
import {
  ClinicAppointmentService,
  BookmarkService,
  RatingService,
  SearchService,
  BodyScanAppointmentService,
} from 'app-service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogRef } from '@angular/material/dialog';

import { AppointmentComponent } from './appointment/appointment.component';
import { AuthGuard } from '../guards/auth.guard';
import { BookmarksComponent } from './bookmarks/bookmarks.component';
import { ListAppointmentsComponent } from './list-appointments/list-appointments.component';
import { SelectClinicComponent } from './select-clinic/select-clinic.component';
import { AppointmentScheduleComponent } from './appointment-schedule/appointment-schedule.component';
import { ClinicServicesComponent } from './clinic-services/clinic-services.component';
import { AppointmentTrackingComponent } from './appointment-tracking/appointment-tracking.component';
import { SelectClinicsComponent } from './select-clinics/select-clinics.component';
import { AppointmentPrescriptionComponent } from './appointment-prescription/appointment-prescription.component';
import { AppointmentReportsComponent } from './appointment-reports/appointment-reports.component';
import { AlphaPrescriptionSheetModule } from 'alpha-prescription-sheet';

@NgModule({
  declarations: [
    AppointmentComponent,
    AppointmentPrescriptionComponent,
    AppointmentReportsComponent,
    AppointmentScheduleComponent,
    AppointmentTrackingComponent,
    BookmarksComponent,
    ClinicServicesComponent,
    ListAppointmentsComponent,
    SelectClinicComponent,
    SelectClinicsComponent,
  ],
  imports: [
    AlphaPrescriptionSheetModule,
    AppSharedUIModule,
    MatTooltipModule,
    RouterModule.forChild([
      {
        path: 'appointment',
        component: ListAppointmentsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appointment/view/appointment/:id1/:id2/:id3',
        component: AppointmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appointment/appointment/:id1/:id2',
        component: AppointmentComponent,
      },
      {
        path: 'appointment/view/services/:id1/:id2/:id3',
        component: AppointmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appointment/view/prescription/:id1/:id2/:id3',
        component: AppointmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appointment/view/reports/:id1/:id2/:id3',
        component: AppointmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appointment/services/:id1/:id2',
        component: AppointmentComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'appointment/:id',
        component: SelectClinicComponent,
      },
      {
        path: 'appointments/:id',
        component: SelectClinicsComponent,
      },
      {
        path: 'bookmarks',
        component: BookmarksComponent,
        canActivate: [AuthGuard],
      },
    ]),
    TranslocoRootModule,
  ],
  providers: [
    BodyScanAppointmentService,
    ClinicAppointmentService,
    BookmarkService,
    {
      provide: MatDialogRef,
      useValue: {},
    },
    DialogService,
    RatingService,
    SearchService,
  ],
})
export class AppointmentModule {}
